// HB-1931: intentional 4xx business-outcome responses. Body must parse as
// JSON `{success:false, error:<code>}` where `<code>` is on the allow-list.
// These are deliberate server-side guard decisions, not bugs — Ledger already
// records them, so Honeybadger noise adds nothing actionable. Extend
// BUSINESS_OUTCOME_ERROR_CODES with team review when new endpoints opt in.

export const BUSINESS_OUTCOME_ERROR_CODES = new Set(["order_state_invalid"]);

export const hasBusinessOutcomeErrorBody = body => {
  if (!body || typeof body !== "string") return false;
  const trimmed = body.trim();
  if (!trimmed.startsWith("{")) return false;
  let parsed;
  try {
    parsed = JSON.parse(trimmed);
  } catch {
    return false;
  }
  if (!parsed || typeof parsed !== "object") return false;
  if (parsed.success !== false) return false;
  return typeof parsed.error === "string" && BUSINESS_OUTCOME_ERROR_CODES.has(parsed.error);
};
